<template>
  <div class="app-container">
    <el-form :model="detail"  ref="addForm" label-width="90px">
      <el-form-item label="公告标题:" prop="name">
        {{detail.noticeTitle}}
      </el-form-item>
      <el-form-item label="公告详情:" prop="detail">
        <Editor  v-if="detail.noticeContent" v-model="detail.noticeContent" :contenteditable="false" :editorId="currentUserId" :editorContent="detail.noticeContent"/>
      </el-form-item>
      <el-form-item  prop="detail">
        <el-button @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Editor from "@/components/wangEditor";
import { tenantNoticeDetail } from '@/api/saas/package'
export default {
    data() {
        return {
            detail: {
                noticeContent: '',
                noticeTitle:null
            }
        }
    },
    components: {
      Editor
    },
    computed: {
      ...mapState({
        currentUserId: state => state.user.userId
      })
    },
    mounted() {
      this.noticeId = this.$route.query.noticeId
      this.noticeDetail()
    },
    methods: {
      noticeDetail() {
        tenantNoticeDetail({
          noticeId: this.noticeId
        }).then(response => {
            this.detail = response.data || {}
          })
          .catch(error => {
            this.loading = false;
          });
      },
      goBack() {
        this.$router.go(-1)
      }
    }
}
</script>
